<template>
  <div class="header-menu">
    <div v-if="$root.loggedIn" class="yellow-bg"></div>
    <div v-if="$root.loggedIn" class="menu c-red">
      <span v-for="(cat, index) in collection" :key="'cat'+index" @click="onClick(cat.categoryslug)">{{cat.category}}</span>
    </div>
  </div>
</template>

<script>
import slugify from 'slugify'
export default {
  name: 'HeaderMenu',

  data () {
    return {
      collection: null
    }
  },

  mounted () {
    console.log(this.$root.config)
    this.getContent()
  },

  methods: {
    getContent () {
      if (this.$route.params.collection) {
        for (let i = 0; i < this.$root.config.collectionmen.length; i++) {
          const col = this.$root.config.collectionmen[i]
          if (col.categoryslug.toLowerCase() === this.$route.params.collection.toLowerCase()) {
            this.collection = this.$root.config.collectionmen
          }
        }

        for (let i = 0; i < this.$root.config.collectionwomen.length; i++) {
          const col = this.$root.config.collectionwomen[i]
          if (col.categoryslug.toLowerCase() === this.$route.params.collection.toLowerCase()) {
            this.collection = this.$root.config.collectionwomen
          }
        }

        for (let i = 0; i < this.$root.config.collectionwomen24.length; i++) {
          const col = this.$root.config.collectionwomen24[i]
          if (col.categoryslug.toLowerCase() === this.$route.params.collection.toLowerCase()) {
            this.collection = this.$root.config.collectionwomen24
          }
        }
      } else if (this.$route.params.product) {
        for (let i = 0; i < this.$root.config.collectionmen.length; i++) {
          const col = this.$root.config.collectionmen[i]
          for (let p = 0; p < col.products.length; p++) {
            const prod = col.products[p]
            if (slugify(this.$route.params.product).toLowerCase() === slugify(prod.slug).toLowerCase()) {
              this.collection = this.$root.config.collectionmen
            }
          }
        }

        for (let i = 0; i < this.$root.config.collectionwomen.length; i++) {
          const col = this.$root.config.collectionwomen[i]
          for (let p = 0; p < col.products.length; p++) {
            const prod = col.products[p]
            if (slugify(this.$route.params.product).toLowerCase() === slugify(prod.slug).toLowerCase()) {
              this.collection = this.$root.config.collectionwomen
            }
          }
        }

        for (let i = 0; i < this.$root.config.collectionwomen24.length; i++) {
          const col = this.$root.config.collectionwomen24[i]
          for (let p = 0; p < col.products.length; p++) {
            const prod = col.products[p]
            if (slugify(this.$route.params.product).toLowerCase() === slugify(prod.slug).toLowerCase()) {
              this.collection = this.$root.config.collectionwomen24
            }
          }
        }
      } else {
        this.collection = [
          {
            category: 'Women',
            categoryslug: 'Women'
          },
          {
            category: 'Men',
            categoryslug: 'Men'
          }
        ]
      }

      console.log('header collection', this.collection)
    },
    onClick (id) {
      if (id === 'Men' || id === 'Women') {
        this.$router.push({ name: id })
      } else if (id === 'about') {
        this.$router.push({ name: 'About' })
      } else {
        this.$router.push({
          name: 'Collection',
          params: {
            collection: id.toLowerCase()
          }
        })
      }
    }
  },

  watch: {
    $route () {
      this.getContent()
    }
  }
}
</script>

<style lang="scss" scoped>
.header-menu {
  position: sticky;
  top: 0;
  z-index: 3;
  pointer-events: all;
  display: inline-block;
  margin-left: 50%;
  text-align: center;
  padding: 10px;
  transform: translate(-50%, 30px);
  white-space: nowrap;
}

h3 {
  letter-spacing: 10px;
}

.menu {
  white-space: normal;
  max-width: 90vw;

  span {
    margin: 0 20px;
    font-size: 24px;
    cursor: pointer;
    transition: opacity 0.5s;
    // text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8), 1px 1px 2px rgba(0, 0, 0, 0.5);
    text-transform: uppercase;
    word-break: keep-all;

    @include breakpoint('xs-only') {
      font-size: 18px;
    }

    &:hover {
      opacity: 0.5;
    }
  }

  .about {
    right: 20px;
    position: absolute;
  }
}
</style>
